<template>
  <div class="bg-white-wrapper">
    <div class="container buy-wrapper">
      <h3 class="buy-header">
        <img src="../../assets/images/shoppimgcar01.png" /> &nbsp;课程购买
      </h3>
      <div class="buy-table">
        <Table :columns="buyColumns" :data="buyData" size="large">
          <template slot-scope="{ row }" slot="course">
            <div class="buy-product">
              <div class="buy-product-image">
                <img :src="concatImageUrl(row.image)" :alt="row.name" />
              </div>
              <div class="buy-product-info">
                <p>{{ row.name }}</p>
                <p>{{ row.courseSet }}</p>
              </div>
            </div>
          </template>
        </Table>
      </div>

      <div class="buy-integral">
        <div class="buy-integral-info" v-show="isEnableIntegral">
          <div class="buy-integral-text">
            积分 共
            <b>{{ integralTotal }}</b> 积分，满 <b>1000</b>积分可用
            <Icon
              type="md-help-circle"
              @click="integralHelpVisible = true"
              title="使用帮助"
            />
          </div>
          <div class="buy-integral-switch">
            <i-switch
              v-model="isUseIntegral"
              @on-change="changeisUseIntegral"
            ></i-switch>
          </div>
        </div>
        <div class="buy-integral-use" v-if="isUseIntegral">
          <i-select
            v-model="userIntegral"
            style="width: 200px"
            @on-change="changeUsedIntegral"
          >
            <i-option
              :value="item"
              v-for="item in useIntegralList"
              :key="item"
              >{{ item }}</i-option
            >
          </i-select>
          <p>
            积分，抵扣
            <b>￥{{ deductionMoney.toFixed(2) }}</b>
          </p>
        </div>

        <div class="clearfix buy-pay">
          <div class="fl buy-pay-remark">
            备注：
            <div class="buy-pay-reamrk-input">
              <i-input
                v-model="userRemark"
                placeholder="若有推荐老师，请输入老师名称"
              ></i-input>
            </div>
          </div>
          <div class="fl buy-pay-agreement" v-if="agreementTitle">
            <Checkbox v-model="agreementIsUse">我已充分阅读服务协议</Checkbox>
            <span class="agreement-title" @click="agreementVisible = true"
              >《{{ agreementTitle }}》</span
            >
          </div>
          <div class="fr buy-pay-info">
            <span class="buy-pay-money">
              需付款：￥
              <b>{{ totalMoney.toFixed(2) }}</b>
            </span>
            <a href="javascript:;" class="buy-pay-btn" @click="buyProduct"
              >立即购买</a
            >
          </div>
        </div>
      </div>
    </div>
    <Drawer
      :title="agreementTitle"
      width="640"
      :closable="false"
      v-model="agreementVisible"
    >
      <div v-html="agreementContent"></div>
    </Drawer>
    <Modal v-model="integralHelpVisible" footer-hide title="使用帮助">
      <p>
        <b>使用条件</b>
      </p>
      <p>1．积分大于1000分（含）</p>
      <p>
        2．积分支付不得超过每笔订单应付金额的 {{ integralSet.lastdeduction }}%
      </p>
      <p>&nbsp;</p>
      <p>
        <b>使用数量</b>
      </p>
      <p>1．使用积分为1000的整倍数</p>
      <p>2．1000积分抵扣{{ integralSet.deduction }}元</p>
    </Modal>
    <!-- sultan -->
    <div class="identity-card-num-cover" v-if="showInputIdentityCardNumFlag">
      <div class="identity-card-num-box">
        <div class="title">
          <span>订单支付</span>
          <span class="close" @click="closeInputIdentityCardNum">×</span>
        </div>
        <div class="content">
          <div class="til">
            <span style="color: #ff4d4f">*</span> 请输入您的身份证号：
          </div>
          <Input
            class="input"
            type="text"
            v-model="identityValue"
            placeholder="请输入身份证号"
            @keyup.enter="inputValue"
          />
        </div>
        <div class="btns-box">
          <div class="btns">
            <Button class="cancel" @click="closeInputIdentityCardNum"
              >取消</Button
            >
            <Button class="confirm" @click="testIdentity">确认</Button>
          </div>
        </div>
      </div>
    </div>

    <Modal
      :title="null"
      v-model="isShowSigningCode"
      ok-text="我已签约完成"
      cancel-text=""
      width="320"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-ok="confirmSigning"
    >
      <div class="code">
        <vue-qr
          :margin="5"
          :size="180"
          :correctLevel="3"
          :text="qrcodeData.url"
          :logoSrc="qrcodeData.icon"
          :logoMargin="5"
          style="display: block; margin: 24px auto"
        ></vue-qr>
      </div>
      <div class="tips" style="text-align: center; color: #258aff">
        请扫码完成签约
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import VueQr from "vue-qr";
import {
  getBuyProduct,
  removeBuyProduct,
  saveOrderInfo,
} from "../../utils/localStorage";
import { order, identity } from "../../request";
import { getToken } from "../../utils/localStorage";
export default {
  mixins: [siteMixin],
  components: {
    VueQr,
  },
  data() {
    return {
      buyColumns: [
        {
          title: "课程",
          slot: "course",
        },
        {
          title: "费用",
          key: "reducedPrice",
          width: 160,
          align: "right",
        },
      ],
      buyData: [],
      isEnableIntegral: false, //是否开启积分
      integralTotal: 0, //总积分
      useIntegralList: [], //积分使用级别列表（1000的整数倍）
      isUseIntegral: false, //是否使用积分
      usedIntegral: 0, //使用的积分
      usedIntegralIndex: 0, //积分使用级别索引
      userRemark: "", //用户备注
      integralHelpVisible: false,
      integralSet: {
        deduction: 0,
      },
      agreementIsUse: false,
      agreementVisible: false,
      agreementTitle: "",
      agreementContent: "",
      showInputIdentityCardNumFlag: false,
      identityValue: "",
      isShowSigningCode: false, //是否显示签约协议二维码
      qrcodeData: {
        url: "",
        icon: "",
      },
      isSign: false, //是否已签约
    };
  },
  computed: {
    deductionMoney() {
      return (this.usedIntegralIndex + 1) * this.integralSet.deduction;
    },
    totalMoney() {
      if (this.buyData.length == 0) return 0;
      let total = this.buyData.reduce((prev, current) => {
        return prev + current.reducedPrice;
      }, 0);
      return this.isUseIntegral ? total - this.deductionMoney : total;
    },
  },
  mounted() {
    this.getBuyData();
  },
  methods: {
    getBuyData() {
      if (this.siteConfig.isShowProductValid == 1) {
        this.buyColumns.splice(1, 0, {
          title: "有效截止时间",
          key: "validTime",
          width: 160,
        });
      }

      this.buyInfo = getBuyProduct();
      if (this.buyInfo) {
        order
          .getProductInfoWithBuy(
            this.buyInfo.productId,
            this.buyInfo.buyType,
            this.loginUser.userId
          )
          .then((res) => {
            //console.log("buyproduct", res);
            if (res.status === 1) {
              const result = res.data;
              this.buyData.push(result.product);
              this.isEnableIntegral =
                result.agencySet.isintegration &&
                result.userIntegral > 1000 &&
                result.product.isIntegral > 0;
              this.integralTotal = result.userIntegral;
              this.useIntegralList = result.integral;
              this.integralSet = result.agencySet;
              //协议
              this.agreementTitle = result.product.agreementTitle;
              this.agreementContent = result.product.agreement;
              // sultan  是否需要输入身份证号
              this.ticketFlag = result.ticketFlag;
              this.ticketNo = result.ticketNo;
            }
          });
      }
    },
    changeisUseIntegral(value) {
      if (value && this.useIntegralList.length > 0) {
        this.userIntegral = this.useIntegralList[0];
      } else {
        this.userIntegral = 0;
      }
    },
    changeUsedIntegral(value) {
      this.userIntegral = value;
      this.usedIntegralIndex = this.useIntegralList.indexOf(value);
    },
    async buyProduct() {
      console.log("this", this);

      if (this.ticketFlag == "Y" && this.ticketNo == "") {
        this.showInputIdentityCardNumFlag = true;
        return;
      }
      if (this.loginUser.ugid == 6) {
        this.$Message.warning("当前是试用账号，请登录后购买");
        setTimeout(() => {
          this.$router.push({ name: "Login" });
        }, 1500);
        return;
      }

      if (!this.isSign) {
        // 已签约完成
        const { data } = await order.getBuyCheckAgreement(
          this.loginUser.userId,
          this.buyInfo.productId
        );
        this.agreementObj = data;
        if (data.agreementSignRule === 1) {
          const authToken = getToken();
          this.$Modal.confirm({
            title: "购买商品协议",
            content:
              "您购买的商品提供一份限务保障协议《协设名称协议名称》，为了保障购买商品双方保障需签约协议后进行购买",
            okText: "立即签约",
            onOk: () => {
              this.qrcodeData.url = `http://${this.siteConfig.mdomain}/me/signingDetail?id=${data.agreementId}&t=${data.t}&source=pc&userId=${this.loginUser.userId}&token=${authToken.nextAuth}`;
              this.isShowSigningCode = true;
            },
          });
          return;
        }
      }
      if (this.buyData.length <= 0) return;
      if (this.agreementTitle && !this.agreementIsUse) {
        this.$Message.warning("请仔细阅读服务协议并勾选！");
        return;
      }
      let orderData = {
        userId: this.loginUser.userId,
        productId: this.buyInfo.productId,
        type: this.buyInfo.buyType,
        memo: this.userIntegral,
        userRemark: this.userRemark,
      };
      if (this.isSign) {
        const { agreementId, agreementRecordId } = this.buyAgreementObj;
        orderData.agreementId = agreementId;
        orderData.agreementRecordId = agreementRecordId;
      }
      order.createOrder(orderData).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          removeBuyProduct();
          const orderNo = res.data.orderNo;
          const money = res.data.money;
          saveOrderInfo(orderNo, money, this.buyData[0].name);
          this.$router.push({ name: "Payment" });
        } else {
          this.$Message.error(this.message);
        }
      });
    },
    closeInputIdentityCardNum() {
      this.showInputIdentityCardNumFlag = false;
      this.identityValue = "";
    },
    testIdentity() {
      let flag = this.validateIdCard(this.identityValue);
      if (flag) {
        let data = {
          userId: this.loginUser.userId,
          ticketNo: this.identityValue,
        };
        console.log(data);
        identity.identityApi(data).then((res) => {
          console.log(res, "输入身份证号");
          if (res.status == 1) {
            this.ticketNo = res.ticketNo;
            this.ticketFlag = res.ticketFlag;
            this.buyProduct();
          }
        });
      }
    },
    validateIdCard(idCard) {
      //15位和18位身份证号码的正则表达式
      var regIdCard =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
          var idCardWi = new Array(
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
          ); //将前17位加权因子保存在数组里
          var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
          var idCardLast = idCard.substring(17); //得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              // alert("恭喜通过验证啦！");
              return true;
            } else {
              this.$Message.error("身份证号码错误！");
              return false;
            }
          } else {
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              // alert("恭喜通过验证啦！");
              return true;
            } else {
              this.$Message.error("身份证号码错误！");
              return false;
            }
          }
        }
      } else {
        this.$Message.error("身份证格式不正确!");
        return false;
      }
    },
    // 已签约完成
    async confirmSigning() {
      // getIsCheckAgreement
      const { agreementId, t } = this.agreementObj;
      const { data } = await order.getIsCheckAgreement({
        agreementId,
        // orderId: "",
        type: 1,
        t,
        userId: this.loginUser.userId,
      });
      if (data.status === 1) {
        this.isSign = true;
        this.buyAgreementObj = data;
        this.buyProduct();
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "签约未完成，请重新签约",
          okText: "重新签约",
          cancelText: "取消",
          onOk: () => {
            this.isShowSigningCode = true;
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.buy-wrapper {
  padding: 10px 0;
  .buy-header {
    color: #000;
    font-size: 2rem;
    font-weight: normal;
    img {
      width: 50px;
      margin-top: -5px;
      .inline-block();
    }
  }
  .buy-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #dcdee2;
    border-bottom: none;
  }
  .buy-product {
    width: 100%;
    padding: 20px 0;
    display: flex;
    align-items: center;
    .buy-product-image {
      flex: 0 0 190px;
      padding-right: 20px;
      img {
        width: 190px;
        height: 100px;
      }
    }
    .buy-product-info {
      flex: 1;
      p {
        &:first-child {
          font-weight: bold;
        }
      }
    }
  }
  .buy-integral {
    padding: 10px 0;
    .buy-integral-info {
      font-size: 1.6rem;
      .buy-integral-text {
        .inline-block();
        i {
          margin-left: 5px;
          font-size: 2rem;
          vertical-align: -0.2em;
          cursor: pointer;
        }
      }
      .buy-integral-switch {
        margin-left: 20px;
        .inline-block();
      }
    }
    .buy-integral-use {
      padding: 20px 0;
      p {
        margin-top: 5px;
        b {
          color: #ff6a00;
        }
      }
    }
  }
  .buy-pay {
    width: 100%;
    padding: 20px 0;
    .buy-pay-remark {
      margin-top: 8px;
      .buy-pay-reamrk-input {
        .inline-block();
        width: 250px;
      }
    }
    .buy-pay-agreement {
      margin: 1.3rem 0 0 2rem;
      .agreement-title {
        cursor: pointer;
        color: #258aff;
      }
    }
    .buy-pay-info {
      .buy-pay-money {
        .inline-block();
        width: 200px;
        height: 48px;
        border: 1px solid #258aff;
        border-radius: 40px;
        text-align: center;
        line-height: 48px;
        margin-right: 20px;
        color: #258aff;
      }
      .buy-pay-btn {
        .inline-block();
        width: 200px;
        height: 48px;
        border-radius: 40px;
        text-align: center;
        line-height: 48px;
        color: white;
        font-size: 1.8rem;
        background: -webkit-linear-gradient(left, #3ec2ff, #258aff);
      }
    }
  }
}
.identity-card-num-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 9999;
  top: 0;
  left: 0;
  .identity-card-num-box {
    width: 480px;
    height: 214px;
    background: #ffffff;
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
      0px 9px 28px 0px rgba(0, 0, 0, 0.05),
      0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .title {
      width: 100%;
      height: 56px;
      line-height: 56px;
      font-size: 16px;
      font-weight: bolder;
      color: rgba(0, 0, 0, 0.85);
      padding: 0 24px;
      position: relative;
      .close {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 24px;
        padding: 0 24px;
        cursor: pointer;
      }
    }
    .content {
      border-top: 1px solid rgba(0, 0, 0, 0.06);
      padding: 16px 24px;
      box-sizing: border-box;
      height: 106px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      .til {
        font-size: 14px;
        margin-bottom: 8px;
      }
      .input {
        width: 360px;
        height: 36px;
        border-radius: 18px;
      }
    }
    .btns-box {
      position: relative;
      height: 52px;
      line-height: 52px;
      .btns {
        position: absolute;
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        button {
          width: 60px;
          height: 32px;
          line-height: 32px;
          text-align: center;
        }
        button + button {
          margin-left: 8px;
        }
        .confirm {
          background: linear-gradient(139deg, #27a4ff, #227efa);
        }
      }
    }
  }
}
</style>
